<template>
  <WdsStack direction-column gap-xs>
    <div>
      <WdsLabel sm subtle>
        {{ trigger }}
      </WdsLabel>
    </div>
    <div>
      <WdsButtonGhost
        class="approval-target-title"
        secondary
        :title="workflowObject.approvable.job.name"
        :href="
          laravelNamedRoute('hires.hire.view', {
            hire: workflowObject.approvable.id,
            tab: 'approvals',
          })
        "
      >
        <div class="overflow-handler">
          {{ workflowObject.approvable.job.name }}
        </div>
      </WdsButtonGhost>
      <WdsText class="tw-ml-1">
        <div class="overflow-handler">
          {{ workflowObject.approvable.worker.name }}
        </div>
      </WdsText>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsButtonGhost, WdsLabel, WdsStack, WdsText } from '@worksome/wds-components'
import { triggerToText } from '@/components/Workflows/Approvals/utilities/triggerToText'
import { ApprovalTrigger } from '@/gql/graphql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'

const props = defineProps({
  workflowObject: {
    type: Object,
    required: true,
  },
})

const trigger = triggerToText(props?.workflowObject?.approval?.trigger as ApprovalTrigger)
</script>

<style lang="scss" scoped>
.approval-target-title {
  display: inline-block !important; // Prevents the ghost button stretching to the entire column when hovered
}

.overflow-handler {
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
